// extracted by mini-css-extract-plugin
export var actionButton = "_bq-1";
export var actionButtons = "_bq-2";
export var actions = "_bq-0";
export var aiUnread = "_bq-10";
export var alignCenter = "_bq-h";
export var backWrapper = "_bq-3";
export var cellContainer = "_bq-4";
export var checkboxContainer = "_bq-5";
export var contentContainer = "_bq-6";
export var contentHeader = "_bq-8";
export var conversationsTableWrapper = "_bq-s";
export var draftReplyBadgeContainer = "_bq-m";
export var dropdownItem = "_bq-b";
export var dropdownItemsContainer = "_bq-a";
export var dropdownTitle = "_bq-c";
export var errorIcon = "_bq-7";
export var filter = "_bq-d";
export var gray = "_bq-i";
export var headerActionButtons = "_bq-e";
export var headerCheckboxContainer = "_bq-f";
export var icon = "_bq-j";
export var menuContainer = "_bq-k";
export var noMoreTicketsIcon = "_bq-12";
export var noMoreTicketsSubText = "_bq-13";
export var oneLine = "_bq-l";
export var optionsButton = "_bq-n";
export var plus = "_bq-o";
export var portalButtonsWrapper = "_bq-g";
export var red = "_bq-p";
export var scrolledTop = "_bq-9";
export var search = "_bq-q";
export var selectedConversationsCount = "_bq-r";
export var spinner = "_bq-t";
export var strong = "_bq-u";
export var summaryCell = "_bq-v";
export var tableContainer = "_bq-11";
export var tagContainer = "_bq-w";
export var threeDots = "_bq-x";
export var twoLines = "_bq-y";
export var unread = "_bq-z";